import { PricingApi, PricingCalculationRequest, PricingCalculationResponse } from '@oncampusabroad/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialApiState, ApiCallBase, createApiConfiguration } from './apiConfiguration';
import { formatDatesInObject } from '../../utils/date-formatter';

interface PricingCalculationCall extends ApiCallBase {
  response: PricingCalculationResponse;
}

interface State {
  pricingCalculation: PricingCalculationCall;
}

const initialState: State = {
  pricingCalculation: initialApiState,
};

export const calculatePricing = createAsyncThunk(
  'pricing/calculatePricing',
  async (request: PricingCalculationRequest) => {
    try {
      const pricingApi = new PricingApi(createApiConfiguration());
      
      const formattedRequest = formatDatesInObject(request);
      
      const response = await pricingApi.checkPricing(formattedRequest);
      return response.data;
    } catch (error) {
      console.error('Error calculating pricing:', error);
      throw error;
    }
  }
);

const PricingSlice = createSlice({
  name: 'pricing',
  initialState,
  reducers: {
    resetPricingCalculation: (state) => {
      state.pricingCalculation = {
        ...initialApiState,
        response: state.pricingCalculation.response,
      };
    },
    resetPricingCalculationResponse: (state) => {
      state.pricingCalculation = {
        ...initialApiState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(calculatePricing.pending, (state) => {
      state.pricingCalculation.loading = 'pending';
    });
    builder.addCase(calculatePricing.fulfilled, (state, action) => {
      state.pricingCalculation.loading = 'succeeded';
      state.pricingCalculation.response = action.payload;
    });
    builder.addCase(calculatePricing.rejected, (state, action) => {
      state.pricingCalculation.loading = 'failed';
      state.pricingCalculation.error = action.payload;
    });
  },
});

export const {
  resetPricingCalculation,
  resetPricingCalculationResponse,
} = PricingSlice.actions;

export default PricingSlice.reducer; 